import type { AdminConfigValueType } from '@carcheck/shared';
import Chip, { type ChipProps } from '@mui/material/Chip';
import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Value-type badge chip for the runtime-config table (AUT-131). One of the
 * four wire `type` discriminators — colour-coded to match the mockup's
 * type column. Labels resolve through i18n (`config.type.<value>`;
 * CLAUDE.md rule #11) — though the values are themselves the literal type
 * names (`number` / `string` / `boolean` / `json`), they stay i18n-keyed
 * for consistency.
 */
type ChipColor = ChipProps['color'];

const TYPE_COLOR: Record<AdminConfigValueType, ChipColor> = {
  number: 'info',
  string: 'default',
  boolean: 'primary',
  json: 'warning',
};

export const ConfigTypeBadge = ({ type }: { type: AdminConfigValueType }): ReactElement => {
  const { t } = useTranslation();
  return (
    <Chip
      size="small"
      variant="outlined"
      color={TYPE_COLOR[type]}
      label={t(`config.type.${type}`)}
    />
  );
};
